module.exports = __webpack_public_path__ + "img/wait.a9522b54.png";